import {CraftingTable} from '../../app/interface/crafting-table';

export let craftingTables: CraftingTable[] =
  [
    {
      'name': 'Advanced Carpentry Table',
      'nameID': 'AdvancedCarpentryTableObject',
      'upgradeModuleType': 'ModernUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_03.png',
      'xPos': 11,
      'yPos': 12
    },
    {
      'name': 'Advanced Masonry Table',
      'nameID': 'AdvancedMasonryTableObject',
      'upgradeModuleType': 'ModernUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_03.png',
      'xPos': 10,
      'yPos': 12
    },
    {
      'name': 'Advanced Tailoring Table',
      'nameID': 'AdvancedTailoringTableObject',
      'upgradeModuleType': 'ModernUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_04.png',
      'xPos': 5,
      'yPos': 13
    },
    {
      'name': 'Anvil',
      'nameID': 'AnvilObject',
      'upgradeModuleType': 'AdvancedUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_00.png',
      'xPos': 5,
      'yPos': 11
    },
    {
      'name': 'Arrastra',
      'nameID': 'ArrastraObject',
      'upgradeModuleType': 'BasicUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_02.png',
      'xPos': 5,
      'yPos': 8
    },
    {
      'name': 'Assembly Line',
      'nameID': 'AssemblyLineObject',
      'upgradeModuleType': 'AdvancedUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_01.png',
      'xPos': 6,
      'yPos': 6
    },
    {
      'name': 'Automatic Loom',
      'nameID': 'AutomaticLoomObject',
      'upgradeModuleType': 'ModernUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_04.png',
      'xPos': 4,
      'yPos': 13
    },
    {
      'name': 'Bakery Oven',
      'nameID': 'BakeryOvenObject',
      'upgradeModuleType': 'AdvancedUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_00.png',
      'xPos': 2,
      'yPos': 12
    },
    {
      'name': 'Blast Furnace',
      'nameID': 'BlastFurnaceObject',
      'upgradeModuleType': 'AdvancedUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_00.png',
      'xPos': 7,
      'yPos': 10
    },
    {
      'name': 'Bloomery',
      'nameID': 'BloomeryObject',
      'upgradeModuleType': 'AdvancedUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_00.png',
      'xPos': 12,
      'yPos': 10
    },
    {
      'name': 'Butchery Table',
      'nameID': 'ButcheryTableObject',
      'upgradeModuleType': 'BasicUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_00.png',
      'xPos': 13,
      'yPos': 10
    },
    {
      'name': 'Campfire',
      'nameID': 'CampfireObject',
      'upgradeModuleType': 'BasicUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_00.png',
      'xPos': 3,
      'yPos': 11
    },
    {
      'name': 'Campsite',
      'nameID': 'CampsiteObject',
      'upgradeModuleType': 'None',
      'hidden': false,
      'imageFile': 'UI_Icons_01.png',
      'xPos': 11,
      'yPos': 1
    },
    {
      'name': 'Capitol',
      'nameID': 'CapitolObject',
      'upgradeModuleType': 'None',
      'hidden': false,
      'imageFile': 'UI_Icons_02.png',
      'xPos': 0,
      'yPos': 10
    },
    {
      'name': 'Carpentry Table',
      'nameID': 'CarpentryTableObject',
      'upgradeModuleType': 'BasicUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_00.png',
      'xPos': 15,
      'yPos': 10
    },
    {
      'name': 'Cast Iron Stove',
      'nameID': 'CastIronStoveObject',
      'upgradeModuleType': 'AdvancedUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_01.png',
      'xPos': 11,
      'yPos': 10
    },
    {
      'name': 'Cement Kiln',
      'nameID': 'CementKilnObject',
      'upgradeModuleType': 'AdvancedUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_00.png',
      'xPos': 9,
      'yPos': 10
    },
    {
      'name': 'Electric Lathe',
      'nameID': 'ElectricLatheObject',
      'upgradeModuleType': 'ModernUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_01.png',
      'xPos': 14,
      'yPos': 1
    },
    {
      'name': 'Electric Machinist Table',
      'nameID': 'ElectricMachinistTableObject',
      'upgradeModuleType': 'ModernUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_01.png',
      'xPos': 15,
      'yPos': 2
    },
    {
      'name': 'Electric Planer',
      'nameID': 'ElectricPlanerObject',
      'upgradeModuleType': 'ModernUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_01.png',
      'xPos': 15,
      'yPos': 1
    },
    {
      'name': 'Electric Stamping Press',
      'nameID': 'ElectricStampingPressObject',
      'upgradeModuleType': 'ModernUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_01.png',
      'xPos': 13,
      'yPos': 1
    },
    {
      'name': 'Electronics Assembly',
      'nameID': 'ElectronicsAssemblyObject',
      'upgradeModuleType': 'ModernUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_05.png',
      'xPos': 10,
      'yPos': 6
    },
    {
      'name': 'Farmers Table',
      'nameID': 'FarmersTableObject',
      'upgradeModuleType': 'BasicUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_01.png',
      'xPos': 7,
      'yPos': 9
    },
    {
      'name': 'Fishery',
      'nameID': 'FisheryObject',
      'upgradeModuleType': 'None',
      'hidden': false,
      'imageFile': 'UI_Icons_03.png',
      'xPos': 0,
      'yPos': 12
    },
    {
      'name': 'Froth Floatation Cell',
      'nameID': 'FrothFloatationCellObject',
      'upgradeModuleType': 'ModernUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_02.png',
      'xPos': 10,
      'yPos': 8
    },
    {
      'name': 'Glassworks',
      'nameID': 'GlassworksObject',
      'upgradeModuleType': 'AdvancedUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_05.png',
      'xPos': 8,
      'yPos': 15
    },
    {
      'name': 'Jaw Crusher',
      'nameID': 'JawCrusherObject',
      'upgradeModuleType': 'ModernUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_02.png',
      'xPos': 7,
      'yPos': 8
    },
    {
      'name': 'Kiln',
      'nameID': 'KilnObject',
      'upgradeModuleType': 'AdvancedUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_00.png',
      'xPos': 4,
      'yPos': 10
    },
    {
      'name': 'Kitchen',
      'nameID': 'KitchenObject',
      'upgradeModuleType': 'AdvancedUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_01.png',
      'xPos': 15,
      'yPos': 9
    },
    {
      'name': 'Laboratory',
      'nameID': 'LaboratoryObject',
      'upgradeModuleType': 'ModernUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_00.png',
      'xPos': 5,
      'yPos': 10
    },
    {
      'name': 'Lathe',
      'nameID': 'LatheObject',
      'upgradeModuleType': 'AdvancedUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_01.png',
      'xPos': 14,
      'yPos': 3
    },
    {
      'name': 'Loom',
      'nameID': 'LoomObject',
      'upgradeModuleType': 'BasicUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_04.png',
      'xPos': 15,
      'yPos': 11
    },
    {
      'name': 'Machinist Table',
      'nameID': 'MachinistTableObject',
      'upgradeModuleType': 'AdvancedUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_04.png',
      'xPos': 6,
      'yPos': 9
    },
    {
      'name': 'Masonry Table',
      'nameID': 'MasonryTableObject',
      'upgradeModuleType': 'BasicUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_00.png',
      'xPos': 8,
      'yPos': 10
    },
    {
      'name': 'Mill',
      'nameID': 'MillObject',
      'upgradeModuleType': 'AdvancedUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_00.png',
      'xPos': 0,
      'yPos': 12
    },
    {
      'name': 'Oil Refinery',
      'nameID': 'OilRefineryObject',
      'upgradeModuleType': 'ModernUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_00.png',
      'xPos': 10,
      'yPos': 10
    },
    {
      'name': 'Pump Jack',
      'nameID': 'PumpJackObject',
      'upgradeModuleType': 'None',
      'hidden': false,
      'imageFile': 'UI_Icons_00.png',
      'xPos': 2,
      'yPos': 1
    },
    {
      'name': 'Research Table',
      'nameID': 'ResearchTableObject',
      'upgradeModuleType': 'None',
      'hidden': false,
      'imageFile': 'UI_Icons_00.png',
      'xPos': 4,
      'yPos': 12
    },
    {
      'name': 'Robotic Assembly Line',
      'nameID': 'RoboticAssemblyLineObject',
      'upgradeModuleType': 'ModernUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_01.png',
      'xPos': 7,
      'yPos': 6
    },
    {
      'name': 'Rocker Box',
      'nameID': 'RockerBoxObject',
      'upgradeModuleType': 'BasicUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_02.png',
      'xPos': 8,
      'yPos': 8
    },
    {
      'name': 'Rolling Mill',
      'nameID': 'RollingMillObject',
      'upgradeModuleType': 'AdvancedUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_01.png',
      'xPos': 4,
      'yPos': 7
    },
    {
      'name': 'Sawmill',
      'nameID': 'SawmillObject',
      'upgradeModuleType': 'AdvancedUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_00.png',
      'xPos': 6,
      'yPos': 12
    },
    {
      'name': 'Screening Machine',
      'nameID': 'ScreeningMachineObject',
      'upgradeModuleType': 'AdvancedUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_02.png',
      'xPos': 9,
      'yPos': 8
    },
    {
      'name': 'Screw Press',
      'nameID': 'ScrewPressObject',
      'upgradeModuleType': 'AdvancedUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_01.png',
      'xPos': 12,
      'yPos': 5
    },
    {
      'name': 'Sensor Based Belt Sorter',
      'nameID': 'SensorBasedBeltSorterObject',
      'upgradeModuleType': 'ModernUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_02.png',
      'xPos': 11,
      'yPos': 8
    },
    {
      'name': 'Shaper',
      'nameID': 'ShaperObject',
      'upgradeModuleType': 'AdvancedUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_01.png',
      'xPos': 15,
      'yPos': 3
    },
    {
      'name': 'Spin Melter',
      'nameID': 'SpinMelterObject',
      'upgradeModuleType': 'ModernUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_04.png',
      'xPos': 3,
      'yPos': 13
    },
    {
      'name': 'Stamp Mill',
      'nameID': 'StampMillObject',
      'upgradeModuleType': 'AdvancedUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_02.png',
      'xPos': 6,
      'yPos': 8
    },
    {
      'name': 'Stove',
      'nameID': 'StoveObject',
      'upgradeModuleType': 'AdvancedUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_00.png',
      'xPos': 7,
      'yPos': 12
    },
    {
      'name': 'Tailoring Table',
      'nameID': 'TailoringTableObject',
      'upgradeModuleType': 'BasicUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_04.png',
      'xPos': 6,
      'yPos': 13
    },
    {
      'name': 'Tool Bench',
      'nameID': 'ToolBenchObject',
      'upgradeModuleType': 'None',
      'hidden': false,
      'imageFile': 'UI_Icons_01.png',
      'xPos': 14,
      'yPos': 9
    },
    {
      'name': 'Wainwright Table',
      'nameID': 'WainwrightTableObject',
      'upgradeModuleType': 'BasicUpgrade',
      'hidden': false,
      'imageFile': 'UI_Icons_00.png',
      'xPos': 3,
      'yPos': 10
    },
    {
      'name': 'Workbench',
      'nameID': 'WorkbenchObject',
      'upgradeModuleType': 'None',
      'hidden': false,
      'imageFile': 'UI_Icons_00.png',
      'xPos': 12,
    },
    {
      'name': 'Mortar and Pestle',
      'nameID': 'MortarandPestleObject',
      'upgradeModuleType': 'None',
      'hidden': false,
      'imageFile': 'UI_Icons_00.png',
      'xPos': 12,
      'yPos': 12
    }
  ];
